import { render, staticRenderFns } from "./CompView.vue?vue&type=template&id=8a0b752e&scoped=true&"
import script from "./CompView.vue?vue&type=script&lang=js&"
export * from "./CompView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0b752e",
  null
  
)

export default component.exports